const getters = {
  userId: (state) => state.app.userId,
  config: (state) => state.app.config.config, // 页面整体配置
  sensitiveWordList: (state) => state.app.config.sensitiveWordList, // 敏感词数组
  tpConfig: (state) => state.app.tpConfig,
  isMac: (state) => state.app.isMac,
  sessionId: (state) => state.app.sessionId,
  channelObj: (state) => state.app.channelObj,
};
export default getters;
